import type { ThemeAppearance } from '@atlaskit/lozenge';

const StatusNameToCategoryMap: { [status: string]: ThemeAppearance } = {
	'to do': 'default',
	done: 'success',
};

export const getCategory = (statusName: string): ThemeAppearance => {
	const cleanStatusName = statusName.toLowerCase().trim();

	if (cleanStatusName in StatusNameToCategoryMap) {
		return StatusNameToCategoryMap[cleanStatusName];
	}

	return 'inprogress';
};
